import { render, staticRenderFns } from "./HelpAndFeedback.vue?vue&type=template&id=7887f9fa&scoped=true"
import script from "./HelpAndFeedback.vue?vue&type=script&lang=js"
export * from "./HelpAndFeedback.vue?vue&type=script&lang=js"
import style0 from "./HelpAndFeedback.vue?vue&type=style&index=0&id=7887f9fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7887f9fa",
  null
  
)

export default component.exports